module.exports = __webpack_public_path__ + "static/media/Social Proof - fallon-michael-bUd6kWoVfII-unsplash.061c0399.jpg";